<router-outlet></router-outlet>


<ejs-toast #toastmessage
           [position]="{ X: 'Right', Y: 'Top' }" 
           [showCloseButton]="true" 
           [timeOut]="3000">
</ejs-toast>
 